module.exports = __webpack_public_path__ + "assets/af02f6b438cc516de3f8936a5b7d27b5.mp3";